module.exports = __webpack_public_path__ + "static/media/blog-5.1a121855.svg";